
export default function Hero() {
  return (
    <section id="home" className="relative pt-32 pb-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-violet-50/40 via-purple-50/20 to-white"></div>
      
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-7xl font-serif font-bold text-gray-900 mb-8 leading-tight">
            Modern iOS Applications
            <br />
            for Enhanced Security
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Expert team developing cutting-edge VPN and Cleaner solutions designed to enhance user experience and improve the security of mobile devices
          </p>
        </div>

        <div className="flex items-center justify-center gap-8 mt-20">
          <div className="transform -rotate-6 hover:rotate-0 transition-transform duration-500">
            <div className="w-72 h-[580px] bg-gradient-to-br from-gray-900 to-gray-800 rounded-[3rem] p-3 shadow-2xl">
              <div className="w-full h-full bg-white rounded-[2.5rem] overflow-hidden">
                <img 
                  src="https://public.readdy.ai/ai/img_res/490a54ea0c3bbf30bba6278d0aff4234.jpg" 
                  alt="VPN Application Interface"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="transform hover:scale-105 transition-transform duration-500 z-10">
            <div className="w-72 h-[600px] bg-gradient-to-br from-gray-900 to-gray-800 rounded-[3rem] p-3 shadow-2xl">
              <div className="w-full h-full bg-white rounded-[2.5rem] overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=elegant%20iOS%20home%20screen%20interface%20with%20modern%20app%20icons%20clean%20white%20background%20minimalist%20design%20professional%20mobile%20interface%20showing%20security%20and%20utility%20apps%20premium%20iOS%20aesthetic&width=288&height=600&seq=hero-center-2&orientation=portrait" 
                  alt="iOS Interface"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="transform rotate-6 hover:rotate-0 transition-transform duration-500">
            <div className="w-72 h-[580px] bg-gradient-to-br from-gray-900 to-gray-800 rounded-[3rem] p-3 shadow-2xl">
              <div className="w-full h-full bg-white rounded-[2.5rem] overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=mobile%20cleaner%20app%20interface%20showing%20storage%20optimization%20with%20green%20gradient%20background%20clean%20design%20iOS%20style%20displaying%20storage%20usage%20charts%20and%20cleanup%20options%20professional%20utility%20app%20screenshot&width=288&height=580&seq=hero-cleaner-3&orientation=portrait" 
                  alt="Cleaner Application Interface"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
